import { useState } from "react";
import { setLanguage } from "../lang";

const LanguageSwitcher = ({ lang, setLang }) => { 
    return (
        <div className="language-switcher" style={{ display: "flex" }}>
            <button
                onClick={() => setLang("en")}
                className={lang === "en" ? "active" : ""}
            >
                EN<br /><img src="https://flagcdn.com/gb.svg" alt="EN" width="30" height="30" />
            </button>

            <button
                onClick={() => setLang("sl")}
                className={lang === "sl" ? "active" : ""}
            >
                SL<br /><img src="https://flagcdn.com/si.svg" alt="SL" width="30" height="30" />
            </button>
        </div>
    );
};

export default LanguageSwitcher;
